import React, { createContext, useState, useContext, useCallback } from "react";
import { isCashRegisterOpen } from "../services/CashRegisterService";

const CashRegisterContext = createContext();

export const CashRegisterProvider = ({ children }) => {
  
  const [cashStatus, setCashStatus] = useState({});
  const [loading, setLoading] = useState(false);

  const [closeCashRegisterModal, setCloseCashRegisterModal] = useState(false);

  const checkCashStatus = useCallback(async (locationId, terminalId) => {
    if (!locationId || !terminalId) return;
    setLoading(true);
    try {
      const response = await isCashRegisterOpen(locationId, terminalId);
      setCashStatus((prev) => ({ ...prev, [locationId]: response.isOpen }));
    } catch (error) {
      console.error('Error al validar caja:', error);
      const message = error?.response?.data?.error_message || "Error al validar caja";
      alert(message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Otras pantallas (ej. Mesas) que ya conocen el estado de la caja lo comparten para que la barra superior lo muestre.
  const setCashOpen = useCallback((locationId, isOpen) => {
    setCashStatus((prev) => (prev[locationId] === isOpen ? prev : { ...prev, [locationId]: isOpen }));
  }, []);

  return (
    <CashRegisterContext.Provider value={{ 
        setCashOpen,
        cashStatus, 
        checkCashStatus, 
        loading,
        closeCashRegisterModal,
        setCloseCashRegisterModal }}>
        {children}
    </CashRegisterContext.Provider>
  );
};

export const useCashRegister = () => useContext(CashRegisterContext);
